import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const PayRedirect = () => {
  const { code } = useParams();

  useEffect(() => {
    if (code) {
      window.location.href = `https://paypage.ngenius-payments.com/?code=${code}`;
    }
  }, [code]);

  return null;
};

export default PayRedirect;
